import { useMemo } from "react";
import { useCategories } from "../../categories.hook";
import styles from "./categories-skin-3.module.css";
import { resizeImage } from "@commons-monorepo/index";
import WidgetContainer from "../../../widget-container";

const CategoriesSkin3 = () => {
  const MAX_CATEGORIES = 5;
  const { categories, data: bestCategories } = useCategories(MAX_CATEGORIES);
  const categoriesToMap = useMemo(() => {
    return categories?.
    slice(
      0,
      bestCategories.length > MAX_CATEGORIES ?
      categories.length - 1 :
      categories.length
    )?.
    map((category: any, index: number) => {
      const c = {
        children:
        <div
          key={`key-${index}`}
          className={styles.category}
          onClick={category.onClick}>

              <img
            loading={"lazy"}
            src={resizeImage(category.image, 0, 0, 50)}
            alt={category.name} />

              <span>{category.name}</span>
            </div>

      };
      return c;
    });
  }, [categories]);

  const viewMoreCategory = useMemo(() => {
    if (categories.length > MAX_CATEGORIES) {
      return categories[categories.length - 1];
    }
    return null;
  }, [categories]);

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}>

      <div className={styles.categoriesSkin3Container}>
        <div className={styles.categories}>
          {categoriesToMap?.map((category: any) => category.children)}
        </div>
        {viewMoreCategory &&
        <div className={styles.viewMore} onClick={viewMoreCategory.onClick}>
            <div className={styles.viewMoreImage}>
              <figure className='icon-plus' />
            </div>
            <span>{viewMoreCategory.name}</span>
          </div>}

      </div>
    </WidgetContainer>);

};

export default CategoriesSkin3;